import React, { useEffect, useState } from 'react';
import axiosInstance from '../../../utils/axiosSetup.js';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import Swal from 'sweetalert2';
import { closeModal } from '../../../action/modalbehaviour.js';


const AddBasicProject = ({list}) => {
    const [departments, setDepartments] = useState([]);

    // VALIDATION RULES
    const schema = Yup.object().shape({
        name: Yup.string().required(),
        type: Yup.string().required(),
    });

    const { register, handleSubmit, formState: { errors }, reset } = useForm({
        mode: 'all',
        resolver: yupResolver(schema)
    });
    
    const onSubmit = async (data) => {
        axiosInstance.post(`${process.env.REACT_APP_API_URL}/basic_project`, data)
            .then(response => {
                Swal.fire({ icon:"success", text:response.data.message});
                reset();
                closeModal("basic_project");
                list();
            })
            .catch(({response:{data}})=>{
                Swal.fire({text:data.message, icon:"error"});
            });
    }

    const fetchDepartments = async () => {      
        axiosInstance.get(`${process.env.REACT_APP_API_URL}/department`)
            .then(response => {
                setDepartments(response.data.data);
            })
            .catch(error => {
                console.log(error);
                setDepartments([]); 
            });
    }
    
    useEffect(() => {
        fetchDepartments();

        const modalElement = document.getElementById('basic_project');

        const handleClose = () => reset();

        if (modalElement) {
            modalElement.addEventListener('hidden.bs.modal', handleClose);
        }
        return () => {
            if (modalElement) {
                modalElement.removeEventListener('hidden.bs.modal', handleClose);
            }
        };
    }, [reset]);

    return (
        <div id="basic_project" className="modal custom-modal fade" role="dialog">
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Add Basic Project</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Project Name <span className="text-danger">*</span></label>
                                        <input type="text" className="form-control" {...register('name')} />
                                        <div className="text-sm text-danger">
                                            {errors.name && <p>{errors.name.message}</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Project Type <span className="text-danger">*</span></label>
                                        <select className="form-control" {...register('type')}>
                                            <option value="">Select Project Type</option>
                                            {departments.map(dep => (
                                                <option key={dep.id} value={dep.id}>{dep.name}</option>
                                            ))}
                                            <option key="0" value="0">Visions</option>
                                        </select>
                                        <div className="text-sm text-danger">
                                            {errors.type && <p>{errors.type.message}</p>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="submit-section">
                                <button type="submit" className="btn btn-primary submit-btn">SUBMIT</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AddBasicProject